import label from './label';
import notifications from './notifications';
import packingslip from './packing-slip';
import returnemail from './return-email';

export default [label, notifications, packingslip, returnemail];
